import { render, staticRenderFns } from "./log-user.vue?vue&type=template&id=67b4c296&scoped=true"
import script from "./log-user.vue?vue&type=script&lang=js"
export * from "./log-user.vue?vue&type=script&lang=js"
import style0 from "./log-user.vue?vue&type=style&index=0&id=67b4c296&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b4c296",
  null
  
)

export default component.exports